import React, { useState, useEffect, useMemo, useCallback } from "react";
import Portal from "../portal/Portal";
import "./inactiveuser.css";
import axios from "axios";
import mqtt from "mqtt";

export default function InactiveUser(props) {
  const userdata = props.logedinuser;
  const activeVehicle = userdata.connectionParam.vehicle;
  const [newemail, setnewEmail] = useState("");
  const [newphone, setnewPhone] = useState("");
  const [feedback, setFeedback] = useState("");
  const [demostatus, setDemoStatus] = useState(false);
  const [click, setClick] = useState(false);
  const handleContactMe = async (e) => {
    e.preventDefault();
    setClick(click === false ? true : false);
    try {
      await axios
        .post("https://services.lafemasystems.co.ke/api/contact", {
          newemail,
          newphone,
        })
        .then((response) => {
          setFeedback(response.data);
        });
    } catch (err) {
      console.log(err);
    }
  };

  //begining of mqtt

  const [client, setClient] = useState(null);
  const [payload, setPayload] = useState({});
  //const [isSubed, setIsSub] = useState("false");
  //const [pubStatus, setpubStatus] = useState("none");
  //const [connectStatus, setConnectStatus] = useState("Track");
  const record = useMemo(() => ({
    host: userdata.connectionParam.host,
    clientId: `${activeVehicle} + ${Math.random().toString(16).substr(2, 8)} `,
    port: userdata.connectionParam.port,
    username: userdata.connectionParam.userName,
    password: userdata.connectionParam.password,
    topic: activeVehicle,
    qos: 0,
  }), [userdata, activeVehicle]);

  //mqtt connect function
  const mqttConnect = (host, mqttOption) => {
    setClient(mqtt.connect(host, mqttOption));
  };

  const handleConnection = async () => {
    const { host, clientId, port, username, password } = record;
    const url = `ws://${host}:${port}/mqtt`;
    const options = {
      keepalive: 30,
      protocolId: "MQTT",
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      will: {
        topic: "WillMsg",
        payload: "Connection Closed abnormally..!",
        qos: 0,
        retain: false,
      },
      rejectUnauthorized: false,
    };
    options.clientId = clientId;
    options.username = username;
    options.password = password;
    mqttConnect(url, options);
  };

  const mqttDisconnect = async () => {
    if (client) {
      client.end(() => {
        //setConnectStatus("Disconnected client");
      });
    }
  };

  const mqttSub = useCallback((subscription) => {
    if (client) {
      const { topic, qos } = subscription;
      client.subscribe(topic, { qos }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
        }
      });
    }
  }, [client]);

  const mqttUnSub = (subscription) => {
    if (client) {
      const { topic } = subscription;
      client.unsubscribe(topic, (error) => {
        if (error) {
          console.log("Unsubscribe error", error);
          return;
        }
        //setIsSub(false);
      });
    }
  };
  const mqttPublish = useCallback((context) => {
    if (client) {
      const { topic, qos, command } = context;
      client.publish(topic, command, { qos }, (error) => {
        if (error) {
          console.log("Publish error: ", error);
        }
      });
    }
  }, [client]);
  
  const fakePublishing = useCallback(() => {
    const fake = {
      topic: record.topic,
      qos: record.qos,
      command: "1234",
    };
    mqttPublish(fake);
  }, [record, mqttPublish]);

  useEffect(() => {
    if (client) {
      client.on("connect", () => {
        mqttSub(record);
        fakePublishing();
      });
      client.on("error", (err) => {
        console.error("Connection error: ", err);
        client.end();
      });
      client.on("reconnect", () => {
        // Handle reconnection logic
      });
      client.on("message", (topic, message) => {
        setPayload({ topic, message: message.toString() });
      });
    }
  }, [client, record, mqttSub, fakePublishing]);
  

  return (
    <div className="prophet">
      {!demostatus ? (
        <div className="inactiveuser">
          <div className="spaceer" />
          <div className="inactivecontent">
            <h1>Tracking Portal</h1>
            <h2>amaizing cars, vehicles and asserts deserve</h2>
            <h1>amaizing tracking solution</h1>
            <p>
              The only platform you will ever need to track your most valuable
              vehicles and asserts: intergrated system, kept simple and loved by
              millions of happy users
            </p>
            <h1 className="getstart">get starterd</h1>
            <div className="starterholder">
              <div className="starter">
                <div>Start Now - It's Simple</div>
                <button onClick={handleContactMe}>Meet an Expert</button>
              </div>
              <div className="starter">
                <div>Demo Account - It's Free</div>
                <button
                  onClick={() => {
                    setDemoStatus("active");
                    handleConnection();
                  }}
                >
                  Use demo Account
                </button>
              </div>
            </div>
            <div className={`expert ${click ? "active" : "inactive"}`}>
              <form>
                <input
                  type="email"
                  placeholder="EMAIL"
                  onChange={(e) => {
                    setnewEmail(e.target.value);
                  }}
                />

                <input
                  type="phone"
                  placeholder="PHONE NO"
                  onChange={(e) => {
                    setnewPhone(e.target.value);
                  }}
                />

                <button type="submit" onClick={handleContactMe}>
                  CONTACT ME
                </button>
                <h2>Or directly call customer care</h2>
                <h2 className="phone_no">+254-703570519</h2>

                <p>{feedback}</p>
              </form>
            </div>
            <div className="bottomspacer" />
          </div>
        </div>
      ) : (
        <Portal
          logedinuser={userdata}
          payload={payload}
          publish={mqttPublish}
          unSub={mqttUnSub}
          disconnect={mqttDisconnect}
          activeVehicle={activeVehicle}
        />
      )}
    </div>
  );
}
